export default __webpack_public_path__ + "static/media/laundry1-beforeA-1440w.0493be95.avif";